import { render, staticRenderFns } from "./MilestonesPage.vue?vue&type=template&id=21b40799&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b40799",
  null
  
)

export default component.exports